var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import { connect } from 'react-redux';
import PrimeraVentana from '../components/primera-ventana';
import { PRIMERA_VENTANA_ID } from '../../constantes';
import * as selectorsZona from '../../selectors/zona';
import { getConfigVentanas } from '../../selectors/config-ventanas';
import { getConfigLibro, getConsolaLupaDefecto } from '../../selectors/config-libro';
import { getConfigLibros, getTextosUsuarioVisible, getImagenUsuarioVisible, getPantallaProps, getConfigPortada, getConfigIndice, getCaducado } from '../../selectors';
import * as textosUsuarioSelectors from '../../texto-usuario/selectors';
import * as selectorsBarraHerramientas from '../../selectors/barra-herramientas';
import { crearTexto, actualizarTexto } from '../../texto-usuario/actions';
import Texto from '../../texto-usuario/texto';
import { TIPO_TEXTO, TIPO_NOTA, TIPO_VINCULO } from '../../texto-usuario/constantes';

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var _configTextosUsuario;

  var configPrimeraVentana = getConfigVentanas(state, PRIMERA_VENTANA_ID) || {};
  var configLibro = getConfigLibro(state, ownProps.libroId);
  var configLibros = getConfigLibros(state);
  var configPrimeraVentanaLibro = configLibro['primera-ventana'] || {};

  var _flotante$escalable$a = _extends({
    flotante: false,
    escalable: false,
    ajusteInicial: 'fijo'
  }, configPrimeraVentana, configPrimeraVentanaLibro),
      flotante = _flotante$escalable$a.flotante,
      escalable = _flotante$escalable$a.escalable,
      ajusteInicial = _flotante$escalable$a.ajusteInicial; // const flotante = configPrimeraVentanaLibro.flotante || configPrimeraVentana.flotante || false
  // const escalable = configPrimeraVentanaLibro.escalable || configPrimeraVentana.escalable || false
  // const ajusteInicial = configPrimeraVentanaLibro.ajusteInicial || configPrimeraVentana.ajusteInicial || 'fijo'
  // extraer datos zona


  var zona = ownProps.zona;
  var consolaAudio = selectorsZona.getConsolaAudio(state, zona) || "";
  var consolaLupa = selectorsZona.getConsolaLupa(state, zona) || getConsolaLupaDefecto(state, ownProps.libroId, PRIMERA_VENTANA_ID) || configPrimeraVentana.lupa || "no,auto";
  var ajuste = selectorsZona.getAjuste(state, consolaLupa);
  var escala = selectorsZona.getEscala(state, consolaLupa);
  var botones = selectorsZona.getBotones(state, zona);
  var contenido = selectorsZona.getContenido(state, zona);
  var configPortada = getConfigPortada(state);
  var configIndice = getConfigIndice(state);
  var mensajeCaducidad = getCaducado(state).msgCaducidad;
  var pantallaProps = getPantallaProps(state);
  var libroIdGuardado = pantallaProps.libroIdGuardado,
      numPaginaGuardado = pantallaProps.numPaginaGuardado,
      numZonaGuardado = pantallaProps.numZonaGuardado; // textos usuario

  var textosUsuarioVisible = getTextosUsuarioVisible(state);
  var textosUsuario = textosUsuarioSelectors.getTextosZona(state, libroIdGuardado, numPaginaGuardado, numZonaGuardado);
  var modoCrearTextoUsuario = textosUsuarioSelectors.getModoCrear(state);
  var imagenUsuarioVisible = getImagenUsuarioVisible(state);
  var textosUsuarioTextoAyuda = selectorsBarraHerramientas.getBoton(state, 'Texto').textoAyuda;
  var configHerramientaTexto = selectorsBarraHerramientas.getBoton(state, 'Texto');
  var configHerramientaNota = selectorsBarraHerramientas.getBoton(state, 'Nota');
  var configHerramientaVinculo = selectorsBarraHerramientas.getBoton(state, 'Vinculo');
  return {
    // ventana
    tieneAnimacion: true,
    configPrimeraVentana: configPrimeraVentana,
    configLibros: configLibros,
    flotante: flotante,
    escalable: escalable,
    // abierta,
    // botonera
    consolaAudio: consolaAudio,
    consolaLupa: consolaLupa,
    botones: botones,
    // contenido
    contenido: contenido,
    configPortada: configPortada,
    configIndice: configIndice,
    mensajeCaducidad: mensajeCaducidad,
    // comportamiento inicial de la ventana respecto al contenido
    // 'contenido' -> la ventana se ajusta al tam de la imagen, 
    // 'fijo' -> la ventana ocupa un 80% aprox de la pantalla
    ajusteInicial: ajusteInicial,
    ajuste: ajuste,
    escala: escala,
    // textos usuario
    modoCrearTextoUsuario: modoCrearTextoUsuario,
    textosUsuario: textosUsuario,
    textosUsuarioVisible: textosUsuarioVisible,
    textosUsuarioTextoAyuda: textosUsuarioTextoAyuda,
    configTextosUsuario: (_configTextosUsuario = {}, _configTextosUsuario[TIPO_TEXTO] = configHerramientaTexto, _configTextosUsuario[TIPO_NOTA] = configHerramientaNota, _configTextosUsuario[TIPO_VINCULO] = configHerramientaVinculo, _configTextosUsuario),
    // pizarra
    imagenUsuarioVisible: imagenUsuarioVisible,
    // zona guardado
    libroIdGuardado: libroIdGuardado,
    numPaginaGuardado: numPaginaGuardado,
    numZonaGuardado: numZonaGuardado
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    // Panel de textos de usuario
    onCrearTextoUsuario: function onCrearTextoUsuario(tipo, x, y, textoHtml, libroIdGuardado, numPaginaGuardado, numZonaGuardado) {
      /*window.console.log('primera-ventana-container -> onCrearTextoUsuario', {
          tipo, x, y, libroIdGuardado, numPaginaGuardado, numZonaGuardado
      })*/
      dispatch(crearTexto(new Texto({
        tipo: tipo,
        x: x,
        y: y,
        textoHtml: textoHtml,
        libroId: libroIdGuardado,
        numPagina: numPaginaGuardado,
        numZona: numZonaGuardado
      })));
    },
    onActualizarTextoUsuario: function onActualizarTextoUsuario(textoId, valores) {
      return dispatch(actualizarTexto(textoId, valores));
    }
  };
};

var PrimeraVentanaContainer = connect(mapStateToProps, mapDispatchToProps)(PrimeraVentana);
export default PrimeraVentanaContainer;